// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { donutChart16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-donut-chart': IconDonutChart;
    }
}

/**
 * The icon component for the 'donutChart' icon
 */
export class IconDonutChart extends Icon {
    public constructor() {
        super(donutChart16X16);
    }
}

registerIcon('icon-donut-chart', IconDonutChart);
export const iconDonutChartTag = 'nimble-icon-donut-chart';
